import { Field, ImageField, LinkField } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from '@gn-audio/jss-components';
import { SitecoreFieldTypes } from '@gn-audio/jss-core';

export type CategoryPromoCarouselProps = {
  items: CategoryPromoSpotItem[];
};

export type CategoryPromoSpotSliderButtonProps = {
  direction: 'left' | 'right';
  onClick: () => void;
  disabled: boolean;
};
export type CategoryPromoSpotProps = {
  fields: SitecoreFieldTypes;
} & ComponentProps;

export type CategoryPromoSpotFields = {
  title: Field<string>;
  description: Field<string>;
  categoryPromoItems: CategoryPromoSpotItem[];
  trackingSpotName?: Field<string>;
};

export type CategoryPromoSlidesGroup = {
  items: CategoryPromoSpotItem[];
  id: string;
};

export type CategoryPromoSpotItem = {
  id: string;
  title: Field<string>;
  description: Field<string>;
  image: ImageField;
  link: LinkField;
  url: Field<string>;
  firstLinkTrackingName?: Field<string>;
};
export type CategoryPromoSlidesProps = {
  items: CategoryPromoSpotItem[];
  isActive: boolean;
};
